"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bitmap = void 0;
/**
 * Bitmap representation of a canvas. Containing RGBA bytes in {@link data}.
 */
var Bitmap = /** @class */ (function () {
    function Bitmap(width, height, data) {
        this.width = width;
        this.height = height;
        if (data === undefined) {
            this.data = new Uint8ClampedArray(width * height * 4);
        }
        else {
            this.data = data;
        }
    }
    return Bitmap;
}());
exports.Bitmap = Bitmap;
//# sourceMappingURL=Bitmap.js.map